import { type ComputedRef, type Ref, onMounted, readonly, ref } from 'vue'

import { useDraggable } from '@vueuse/core'

export const useDraggableZoom = (
  zoomElement: Ref,
  zoomWrapperElement: Ref,
  draggingElement: Ref,
  isEnabled: ComputedRef<boolean>
) => {
  const zoomXPosition = ref(0)
  const zoomYPosition = ref(0)
  const dragActive = ref(false)

  onMounted(() => {
    const { x, y, isDragging } = useDraggable(zoomElement, {
      preventDefault: true,
      capture: true,
      draggingElement,
      onMove: () => {
        const width = zoomWrapperElement.value.offsetWidth
        const height = zoomWrapperElement.value.offsetHeight

        if (Math.abs(x.value) < width / 2 && isEnabled.value) {
          zoomXPosition.value = x.value
        }

        if (Math.abs(y.value) < height / 2 && isEnabled.value) {
          zoomYPosition.value = y.value - 50
        }

        dragActive.value = isDragging.value
      },
    })
  })

  return {
    xRef: readonly(zoomXPosition),
    yRef: readonly(zoomYPosition),
    isDragging: readonly(dragActive),
  }
}
